import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { knowledge, getTypePrefix } from '@/api'

/**
 * 获取知识库所有菜单
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getAllKnowledgeCatalogListAction = createAsyncThunk(
    getTypePrefix(knowledge.getAllKnowledgeCatalogList),
    async (data) => await okHttp(knowledge.getAllKnowledgeCatalogList, {
        method: 'POST',
	    data
    })
)

/**
 * 添加知识库菜单
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const addKnowledgeCatalogInfoAction = createAsyncThunk(
    getTypePrefix(knowledge.addKnowledgeCatalogInfo),
    async (data) => await okHttp(knowledge.addKnowledgeCatalogInfo, {
        method: 'POST',
	    data
    })
)

/**
 * 编辑菜单
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const modifyKnowledgeCatalogAction = createAsyncThunk(
    getTypePrefix(knowledge.modifyKnowledgeCatalog),
    async (data) => await okHttp(knowledge.modifyKnowledgeCatalog, {
        method: 'POST',
        data
    })
)

/**
 * 删除菜单
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const removeKnowledgeCatalogAction = createAsyncThunk(
    getTypePrefix(knowledge.removeKnowledgeCatalog),
    async (data) => await okHttp(knowledge.removeKnowledgeCatalog, {
        method: 'POST',
        data
    })
)

/**
 * 获取知识规则列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryKnowledgeRulePageAction = createAsyncThunk(
    getTypePrefix(knowledge.queryKnowledgeRulePage),
    async (data) => await okHttp(knowledge.queryKnowledgeRulePage, {
        method: 'POST',
        ...data
    })
)

/**
 * 添加知识规则
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const addKnowledgeRuleAction = createAsyncThunk(
    getTypePrefix(knowledge.addKnowledgeRule),
    async (data) => await okHttp(knowledge.addKnowledgeRule, {
        method: 'POST',
        data
    })
)

/**
 * 修改知识规则
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const modifyKnowledgeRuleAction = createAsyncThunk(
    getTypePrefix(knowledge.modifyKnowledgeRule),
    async (data) => await okHttp(knowledge.modifyKnowledgeRule, {
        method: 'POST',
        data
    })
)

/**
 * 修改知识规则
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const removeKnowledgeRuleAction = createAsyncThunk(
    getTypePrefix(knowledge.removeKnowledgeRule),
    async (data) => await okHttp(knowledge.removeKnowledgeRule, {
        method: 'POST',
        data
    })
)

/**
 * 查询coze chat token
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryCozeChatTokenAction = createAsyncThunk(
    getTypePrefix(knowledge.queryCozeChatToken),
    async (data) => await okHttp(knowledge.queryCozeChatToken, {
        method: 'POST',
        data
    })
)

/**
 * 批量导入基础问答
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const batchImportKnowledgeAction = createAsyncThunk(
    getTypePrefix(knowledge.batchImportKnowledge),
    async (data) => await okHttp(knowledge.batchImportKnowledge, {
        method: 'POST',
        data,
        contentType: 'multipart/form-data'
    })
)

/**
 * 批量删除基础问答
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */

export const batchRemoveKnowledgeRuleAction = createAsyncThunk(
    getTypePrefix(knowledge.batchRemoveKnowledgeRule),
    async (data) => await okHttp(knowledge.batchRemoveKnowledgeRule, {
        method: 'POST',
        data
    })
)

/**
 * 批量开启或关闭基础问答
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */

export const batchModifyValidEnableAction = createAsyncThunk(
    getTypePrefix(knowledge.batchModifyValidEnable),
    async (data) => await okHttp(knowledge.batchModifyValidEnable, {
        method: 'POST',
        data
    })
)

/**
 * 批量修改分组
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */

export const batchModifyKnowledgeCatalogAction = createAsyncThunk(
    getTypePrefix(knowledge.batchModifyKnowledgeCatalog),
    async (data) => await okHttp(knowledge.batchModifyKnowledgeCatalog, {
        method: 'POST',
        data
    })
)

/**
 * 导出基础问答
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */

export const batchDownloadKnowledgeAction = createAsyncThunk(
    getTypePrefix(knowledge.batchDownloadKnowledge),
    async (data) => await okHttp(knowledge.batchDownloadKnowledge, {
        method: 'POST',
        data
    })
)

/**
 * 获取问答时效列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryKnowledgeTimeConfigPageAction = createAsyncThunk(
    getTypePrefix(knowledge.queryKnowledgeTimeConfigPage),
    async (data) => await okHttp(knowledge.queryKnowledgeTimeConfigPage, {
        method: 'POST',
        data
    })
)

/**
 * 新增问答时效
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const addKnowledgeTimeConfigAction = createAsyncThunk(
    getTypePrefix(knowledge.addKnowledgeTimeConfig),
    async (data) => await okHttp(knowledge.addKnowledgeTimeConfig, {
        method: 'POST',
        data
    })
)

/**
 * 编辑问答时效
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const modifyKnowledgeTimeConfigAction = createAsyncThunk(
    getTypePrefix(knowledge.modifyKnowledgeTimeConfig),
    async (data) => await okHttp(knowledge.modifyKnowledgeTimeConfig, {
        method: 'POST',
        data
    })
)

/**
 * 修改问答时效状态
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const modifyKnowledgeTimeStatusAction = createAsyncThunk(
    getTypePrefix(knowledge.modifyKnowledgeTimeStatus),
    async (data) => await okHttp(knowledge.modifyKnowledgeTimeStatus, {
        method: 'POST',
        data
    })
)

/**
 * 删除问答时效
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const removeKnowledgeTimeConfigAction = createAsyncThunk(
    getTypePrefix(knowledge.removeKnowledgeTimeConfig),
    async (data) => await okHttp(knowledge.removeKnowledgeTimeConfig, {
        method: 'POST',
        data
    })
)
